import React, { useEffect, useState, useRef } from "react";
import { auth } from "../../firebase/firebase.utils";
import { useHistory } from "react-router";
import { useSelector } from "react-redux";
import Subtext from "../sub-text/sub-text.component";
import settings from "../../assets/settings-blue.svg";
import Navitem from "../nav-item/nav-item.component";
import PreferenceIcon from "../../assets/user-preference.svg";
import SettingsIcon from "../../assets/setting-icon.svg";
import ReportAnIssueIcon from "../../assets/report-issue.svg";
import Help from "../help/help.component";
import "./navbar-dropdown.styles.scss";

const NavbarDropdown = () => {
  const [show, setShow] = useState(false);
  const [showHelp, setShowHelp] = useState(false);
  const ref = useRef(null);
  const { user } = useSelector((state) => state.base);
  const history = useHistory();

  const handleClickOutside = (event) => {
    if (event.target.name === "settings") {
      setShow(!show);
    } else if (ref.current && !ref.current.contains(event.target)) {
      setShow(false);
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleClickOutside, true);
    return () => {
      document.removeEventListener("click", handleClickOutside, true);
    };
  });

  const handleReportIssue = () => {
    setShowHelp(true);
  };

  return (
    <div className="navbar-dropdown-container">
      <div className="header-image">
        <button className="nav-button report-issue" onClick={handleReportIssue}>
          <img
            alt=""
            src={ReportAnIssueIcon}
            name="settings"
            className="report-issue-icon"
          />
          Report an issue
        </button>
        <button
          className="nav-button preferences"
          onClick={() => history.push("/settings/manageusers")}
        >
          <img
            alt=""
            src={SettingsIcon}
            name="settings"
            className="settings-icon"
          />
          Preferences
        </button>

        <img
          alt=""
          src={PreferenceIcon}
          name="settings"
          className="user-settings-icon"
        />

        {/* <Navitem name="settings" right>
          <img alt="" src={settings} name="settings" />
          Settings
        </Navitem> */}
      </div>
      {show && (
        <span ref={ref} className="dropdown">
          {user.email ? (
            <Subtext black xs onClick={() => user.email}>
              <i className="fas fa-user"></i>
              {user.email}
            </Subtext>
          ) : (
            ""
          )}
          <Subtext
            black
            onClick={() => {
              history.push("/update-password");
              setShow(false);
            }}
            small
          >
            <i className="fas fa-lock"></i>Change Password
          </Subtext>
          {/* {user.role === "admin" ? (
            <Subtext
              gray
              onClick={() => {
                history.push("/settings/manageusers");
                setShow(false);
              }}
              small
            >
              <i className="fas fa-cog"></i>Preferences
            </Subtext>
          ) : (
            ""
          )} */}

          {/* <Subtext
            small
            black
            onClick={() => history.push("/survey?admin=true")}
          >
            <i className="fas fa-sign-out-alt"></i>Submit on behalf of
          </Subtext> */}

          <Subtext small black onClick={() => auth.signOut()}>
            <i className="fas fa-sign-out-alt"></i>Logout
          </Subtext>
        </span>
      )}

      {showHelp && <Help showHelp={showHelp} setShowHelp={setShowHelp} />}
    </div>
  );
};

export default NavbarDropdown;
